<button type="button" class="layout-topbar-action" (click)="open($event)">
    <!-- div wrappers (not span): the topbar hides every <span> inside an action
         on desktop, which would swallow the icon + dot. -->
    <div class="relative inline-flex">
        <i [class]="aiIcon"></i>
        <div
            class="absolute -top-1 -right-1 w-2 h-2 rounded-full ring-1 ring-surface-0 dark:ring-surface-900"
            [ngClass]="statusDotClass()"
        ></div>
    </div>
    <span>AI Assist</span>
</button>

<p-popover #popover [style]="{ width: '22rem' }">
    <div class="flex flex-col gap-4 p-2">
        <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-2">
                <i [class]="aiIcon" class="text-xl"></i>
                <span class="font-semibold">AI Assist</span>
            </div>
            <p-tag [value]="statusLabel()" [severity]="statusSeverity()" />
        </div>

        @if (aiAssist.health(); as h) {
            <div class="flex flex-col gap-2 text-sm">
                <div class="flex justify-between items-center">
                    <span class="text-muted-color">Version</span>
                    <span class="font-mono">{{ h.version }}</span>
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-muted-color">Database</span>
                    <p-tag
                        [value]="h.db.reachable ? 'OK' : 'Down'"
                        [severity]="h.db.reachable ? 'success' : 'danger'"
                    />
                </div>
                <div class="flex justify-between items-center">
                    <span class="text-muted-color">Active jobs</span>
                    <span class="font-medium">{{ h.active_jobs }}</span>
                </div>
                <div class="border-t border-surface pt-2">
                    <div class="text-sm font-medium mb-2">Vendors</div>
                    <div class="flex flex-wrap gap-2">
                        <p-tag value="Grok" [severity]="h.vendors_reachable.grok ? 'success' : 'danger'" />
                        <p-tag value="FLUX" [severity]="h.vendors_reachable.flux ? 'success' : 'danger'" />
                        <p-tag value="Recraft" [severity]="h.vendors_reachable.recraft ? 'success' : 'danger'" />
                    </div>
                </div>
            </div>
        } @else if (aiAssist.healthLoading()) {
            <div class="flex flex-col gap-2">
                <div class="flex justify-between items-center">
                    <p-skeleton width="5rem" height="1rem" />
                    <p-skeleton width="4rem" height="1rem" />
                </div>
                <div class="flex justify-between items-center">
                    <p-skeleton width="5rem" height="1rem" />
                    <p-skeleton width="3rem" height="1.25rem" />
                </div>
                <div class="flex justify-between items-center">
                    <p-skeleton width="5rem" height="1rem" />
                    <p-skeleton width="2rem" height="1rem" />
                </div>
                <div class="border-t border-surface pt-2">
                    <p-skeleton width="4rem" height="1rem" styleClass="mb-2" />
                    <div class="flex gap-2">
                        <p-skeleton width="3rem" height="1.25rem" />
                        <p-skeleton width="3rem" height="1.25rem" />
                        <p-skeleton width="3.5rem" height="1.25rem" />
                    </div>
                </div>
            </div>
        } @else {
            <div class="flex items-center gap-2 text-sm text-muted-color">
                <i class="pi pi-exclamation-triangle text-red-500"></i>
                <span>Service unavailable — could not reach the AI Assist service.</span>
            </div>
        }

        <div class="border-t border-surface pt-3">
            <div class="text-sm font-medium mb-2">Vendor credits</div>
            @if (aiAssist.vendorBalances(); as b) {
                <div class="flex flex-col gap-2 text-sm">
                    @for (v of b.vendors; track v.vendor) {
                        <div class="flex justify-between items-center gap-2">
                            <span class="text-muted-color">{{ vendorLabel(v.vendor) }}</span>
                            <div class="flex items-center gap-2">
                                <span class="font-medium">{{ balanceLabel(v) }}</span>
                                <p-tag [value]="v.status" [severity]="balanceSeverity(v.status)" />
                                @if (dashboardUrl(v.vendor); as url) {
                                    <a
                                        [href]="url"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="text-muted-color hover:text-primary"
                                        [attr.aria-label]="'Open ' + vendorLabel(v.vendor) + ' console'"
                                    >
                                        <i class="pi pi-external-link text-xs"></i>
                                    </a>
                                }
                            </div>
                        </div>
                    }
                </div>
            } @else if (aiAssist.vendorBalancesLoading()) {
                <div class="flex flex-col gap-2">
                    @for (row of [1, 2, 3]; track row) {
                        <div class="flex justify-between items-center gap-2">
                            <p-skeleton width="4rem" height="1rem" />
                            <p-skeleton width="6rem" height="1.25rem" />
                        </div>
                    }
                </div>
            } @else {
                <span class="text-sm text-muted-color">Could not load vendor credits.</span>
            }
        </div>

        <div class="border-t border-surface pt-3">
            <p-button
                label="Refresh"
                icon="pi pi-refresh"
                severity="secondary"
                [style]="{ width: '100%' }"
                (onClick)="refresh()"
            />
        </div>
    </div>
</p-popover>
